import './news.scss';
import $ from 'jquery';
import NewsAPIService from './NewsAPIService';

export default function () {
    const $newsContainer = $(".product-model-news-container");
    const bgImageDefault = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=";
    if (!$newsContainer.length) return;

    const newsHandler = (data) => {
        if (data.length < 4) return;

        $.each(data.slice(0, 4), function (index, item) {
            let evenOddSelector = 'even';
            let htmlTemplate = `<div class="col-xs-6 product-model-news-item">
                <a href="${item.link}" class="j-news product-model-news-link crux-article__bold-link crux-article__bold-link--small">
                <div class="img-container">
                <svg class="blended-background">
                    <defs>
                      <filter id="imageFilter-${index}">
                        <feImage
                            xlink:href="${item.image || bgImageDefault}"
                            result="slide${index}"
                            x="0"
                            y="0"
                            width="100%"
                            preserveAspectRatio="xMidYMid slice"
                        />
                      <feBlend in2="SourceGraphic" in="slide${index}" mode="multiply" />
                      </filter>
                    </defs>
                  <rect x="0" y="0" width="100%" height="100%" filter="url(#imageFilter-${index})" />
                </svg>
                </div>
                <span class="product-model-news-title">${item.title}</span>
                </a>
                </div>`;

            if (index > 1) {
                evenOddSelector = 'odd';
            }

            $(`.product-model-news-items:${evenOddSelector} > .row`).append(htmlTemplate);
        });

        $newsContainer.show();
        $(document).trigger('NEWS_LOADED');
    };

    NewsAPIService.requestProductNews($newsContainer.data()).done(newsHandler);

}



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/shared/News/index.js